const a = "#002566", t = "#001333", e = "#ff3347", s = "#ff0019", n = "#f2f3f5", r = "#ccd0d6", o = "#646e82", c = "#66bcff", f = "#33a6ff", i = "#99d3ff", l = "#001333", p = "#002566", g = "#f2f3f5", k = "#e6e7eb", D = "#ffffff", h = "#001333", L = "#001333", d = "#fec000", y = "#fec000", F = "#ffa600", C = "#001333", u = "#ff66d1", S = "#ffa6e4", x = "#ff40b2", T = "#660032", P = "#001333", b = "#646e82", E = "#1a2b47", M = "#ff808c", m = "#ff596a", B = "#ffa6af", I = "#400006", W = "#001333", v = "#ffba66", A = "#ff8f33", j = "#ffd199", q = "#401600", w = "#001333", z = "#66bcff", G = "#33a6ff", H = "#99d3ff", J = "#002566", K = "#001333", N = "#72e072", O = "#43d643", Q = "#a1eba1", R = "#004400", U = "#001333", V = "#00091a", X = "#0d1f3d", Y = "#122441", Z = "#142643", _ = "#172845", $ = "#1a2b47", aa = "#ffffff", ta = "#001333", ea = "#646e82", sa = "#99a1ad", na = "#005dff", ra = "#004acc", oa = "#0090ff", ca = "#ffffff", fa = "#e6f4ff", ia = "#001333", la = "#00091a", pa = "#33425c", ga = "#ffffff", ka = "#f2f3f5", Da = "#ffd700", ha = "#ffe000", La = "#fec000", da = "#001333", ya = "#e6e7eb", Fa = "#cc0014", Ca = "#99000f", ua = "#ff0019", Sa = "#ffe6e8", xa = "#ffffff", Ta = "#cc4700", Pa = "#993500", ba = "#ff5900", Ea = "#fff6e6", Ma = "#ffffff", ma = "#0090ff", Ba = "#005dff", Ia = "#33a6ff", Wa = "#e6f4ff", va = "#ffffff", Aa = "#008800", ja = "#006600", qa = "#00aa00", wa = "#e8fae8", za = "#ffffff", Ga = "#cc0065", Ha = "#ff007e", Ja = "#99004c", Ka = "#ffe6fa", Na = "#ffffff", Oa = "#ffffff", Qa = "#ccd0d6", Ra = 700;
export {
  c as $,
  va as A,
  Wa as B,
  Aa as C,
  ja as D,
  qa as E,
  za as F,
  wa as G,
  ta as H,
  ea as I,
  sa as J,
  Da as K,
  ha as L,
  La as M,
  da as N,
  Ga as O,
  Ha as P,
  Ja as Q,
  Na as R,
  Ka as S,
  Oa as T,
  ya as U,
  Qa as V,
  X as W,
  Y as X,
  Z as Y,
  _ as Z,
  $ as _,
  ra as a,
  f as a0,
  i as a1,
  l as a2,
  p as a3,
  g as a4,
  k as a5,
  D as a6,
  h as a7,
  L as a8,
  M as a9,
  u as aA,
  S as aB,
  x as aC,
  P as aD,
  T as aE,
  V as aF,
  b as aG,
  E as aH,
  aa as aI,
  e as aJ,
  s as aK,
  m as aa,
  B as ab,
  W as ac,
  I as ad,
  v as ae,
  A as af,
  j as ag,
  w as ah,
  q as ai,
  z as aj,
  G as ak,
  H as al,
  K as am,
  J as an,
  N as ao,
  O as ap,
  Q as aq,
  U as ar,
  R as as,
  n as at,
  r as au,
  o as av,
  d as aw,
  y as ax,
  F as ay,
  C as az,
  a as b,
  oa as c,
  ca as d,
  fa as e,
  ia as f,
  t as g,
  la as h,
  pa as i,
  ga as j,
  ka as k,
  Fa as l,
  Ca as m,
  ua as n,
  xa as o,
  na as p,
  Sa as q,
  Ta as r,
  Pa as s,
  Ra as t,
  ba as u,
  Ma as v,
  Ea as w,
  ma as x,
  Ba as y,
  Ia as z
};
